angular.module('surfsightApp.controllers').controller('UsersCtrl', [
  '$scope',
  '$http',
  '$filter',
  '$localStorage',
  '$mdDialog',
  '$mdToast',
  '$interval',
  '$timeout',
  '$mdSidenav',
  'organizationFactory',
  'userFactory',
  'dataFromCaller',
  function (
    $scope,
    $http,
    $filter,
    $localStorage,
    $mdDialog,
    $mdToast,
    $interval,
    $timeout,
    $mdSidenav,
    organizationFactory,
    userFactory,
    dataFromCaller
  ) {
    $scope.partnerData = $localStorage.partnerData
    var resellerID = $scope.partnerData.id
    $scope.newUser = {}
    $scope.cancel = function () {
      $mdDialog.cancel()
    }
    $scope.newUser.organizationId = parseInt(dataFromCaller.organizationId)
    $scope.newUser.organizationIds = []
    $scope.load_organizations = function () {
      $scope.organizations = []
      $scope.loading = true
      var request_json = {
        method: 'GET',
        url: USER_BASEURL + '/reseller/' + resellerID + '/organizations'
      }
      $http(request_json).then(
        function (response) {
          if (response.data.status.code == 0) {
            $scope.organizations = response.data.organizations
          } else {
            alert(response.data.status.error)
          }
          $scope.loading = false
        },
        function () {
          alert('Error Occurred')
          $scope.loading = false
        }
      )
    }
    $scope.load_organizations()
    $scope.addUser = function () {
      var email = $scope.newUser.email
      var password = $scope.newUser.password
      var role = $scope.newUser.role

      if (email && password && role) {
        var request_json = {
          method: 'POST',
          url: USER_BASEURL + '/user',
          data: $scope.newUser
        }
        $http(request_json).then(
          function (response) {
            if (response.data.status.code == 0) {
              $mdDialog.hide(response)
            } else {
              var toast = $mdToast
                .simple()
                .textContent(response.data.status.error)
                .action('ok')
                .position('bottom')
                .actionKey('F1')
                .hideDelay(5000)
                .parent('#add-user-container')

              $mdToast
                .show(toast)
                .then(function (response) {
                  if (response == 'ok') {
                  }
                })
                .catch(() => {})
            }
          },
          function (response) {
            if (response && response.data) {
              if (response.data.statusCode == 401) {
                $state.go('home.login')
              }
            } else {
              $scope.showMessageToast('Error occurred.')
            }
          }
        )
      }
    }
    $scope.showMessageToast = function (message) {
      var toast = $mdToast
        .simple()
        .textContent(message)
        .action($translate('ok'))
        .position('top right')
        .actionKey('F1')
        .hideDelay(5000)
      $mdToast
        .show(toast)
        .then(function (response) {
          if (response == 'ok') {
          }
        })
        .catch(() => {})
    }
  }
])
